import { AmlFlowEnum } from '@/api';

const legacyToNewFlowMap: Partial<Record<AmlFlowEnum, AmlFlowEnum>> = {
  [AmlFlowEnum.LIGHT]: AmlFlowEnum.LITE,
};

const flowDisplayMap: Record<AmlFlowEnum, string> = {
  [AmlFlowEnum.ADVANCED_LIMITED]: `${AmlFlowEnum.ADVANCED}(PRO)`,
  [AmlFlowEnum.FAST_LIMITED]: `${AmlFlowEnum.FAST}(PRO)`,
  [AmlFlowEnum.ACCURATE]: AmlFlowEnum.ACCURATE,
  [AmlFlowEnum.ADVANCED]: `${AmlFlowEnum.ADVANCED}(PRO+)`,
  [AmlFlowEnum.FAST]: `${AmlFlowEnum.FAST}(PRO+)`,
  [AmlFlowEnum.LIGHT]: AmlFlowEnum.LITE,
  [AmlFlowEnum.LITE]: AmlFlowEnum.LITE,
  [AmlFlowEnum.INSTANT]: AmlFlowEnum.INSTANT,
};

export { flowDisplayMap, legacyToNewFlowMap };
